export const fileToDataUrl = async (reader: FileReader, file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    reader.readAsDataURL(file)
    reader.onload = () => {
      resolve(reader.result as string)
    }
    reader.onerror = reject
  })
